module.exports = __webpack_public_path__ + "static/img/material_test.c138335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material_test.png
// module id = mrC/
// module chunks = 1